import React from 'react';
import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import '../styles/App.css';

const Footer = () => {
  const { t } = useTranslation();
  const currentYear = new Date().getFullYear();

  return (
    <footer className="footer">
      <div className="footer-container">
        {/* Brand Section */}
        <div className="footer-brand">
          <h3 className="footer-brand-name">
            <img src="/logo-white.png" alt="RifaMaker" style={{ height: '32px', verticalAlign: 'middle' }} />
          </h3>
          <p className="footer-description">
            {t('footer.description')}
          </p>
        </div>

        {/* Links Section */}
        <div className="footer-links">
          <div className="footer-link-group">
            <h4 className="footer-link-title">{t('footer.legal')}</h4>
            <ul className="footer-link-list">
              <li>
                <Link to="/terms" className="footer-link">
                  {t('footer.terms')}
                </Link>
              </li>
              <li>
                <Link to="/privacy" className="footer-link">
                  {t('footer.privacy')}
                </Link>
              </li>
              <li>
                <Link to="/contact" className="footer-link">
                  {t('footer.contact')}
                </Link>
              </li>
            </ul>
          </div>
        </div>

        {/* Legal Micro-Disclaimer */}
        <div style={{
          padding: '1rem 0',
          borderTop: '1px solid rgba(255,255,255,0.1)',
          marginTop: '0.5rem',
          fontSize: '0.75rem',
          color: 'rgba(255,255,255,0.45)',
          lineHeight: 1.6,
          textAlign: 'center',
          maxWidth: '700px',
          marginLeft: 'auto',
          marginRight: 'auto',
        }}>
          {t('footer.legalDisclaimer')}
        </div>

        {/* Copyright Section */}
        <div className="footer-copyright">
          <p className="copyright-text">
            &copy; {currentYear} RifaMaker. {t('footer.allRightsReserved')}
          </p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
